import { useTranslation } from 'react-i18next';
import { cn } from '@utils/cn';
import { chipClass } from '../constants';
import { isShowAll, toggleFilter } from '../helpers';
import { FilterChipsProps } from './types';

export const FilterChips = ({
  value,
  onChange,
  keys = ['qualified', 'available', 'onSchedule'],
}: FilterChipsProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'scheduling.phone.filters' });
  const chip = (active: boolean) =>
    cn('h-8 whitespace-nowrap rounded-md border px-3 text-[13px]', chipClass(active));

  return (
    <div className="flex flex-wrap gap-1.5">
      {keys.map((key) => (
        <button
          key={key}
          type="button"
          aria-pressed={value[key]}
          className={chip(value[key])}
          onClick={() => onChange(toggleFilter(value, key))}>
          {t(key)}
        </button>
      ))}
      <button
        type="button"
        aria-pressed={isShowAll(value)}
        className={chip(isShowAll(value))}
        onClick={() => onChange({ qualified: false, available: false, onSchedule: false })}>
        {t('showAll')}
      </button>
    </div>
  );
};
